<!-- <app-status-bar /> -->
<!-- <app-nav-bar /> -->
<!-- <div class="md:ml-16 px-2"> -->
<div class="px-2">
  <router-outlet />
</div>
<app-drawer-host />
<p-toast />
